import {
  REQUEST_POPUP_LIST,
  REQUEST_POPUP,
} from './mutation-types'

import axiosInst from '@/utility/axiosInst'

export default {
  requestSavePopup({}, payload) {
    return axiosInst.springAxiosInst.post('/admin/popup/save-popup', payload)
    .then((res) => {
      return res.data
    })
  },

  requestPopupList({commit}, payload) {
    const {currentPage, searchType, searchWord} = payload
    return axiosInst.springAxiosInst.get("/admin/popup/popup-list", {
      params: {
        page: currentPage,
        searchType: searchType,
        searchWord : searchWord
      }
    }).then((res) => {
      commit(REQUEST_POPUP_LIST, res.data)
    })
  },

  requestPopup({commit}, popupSeq) {
    return axiosInst.springAxiosInst.get(`/admin/popup/popup/${popupSeq}`)
    .then((res) => {
      commit(REQUEST_POPUP, res.data)
    })
  },

  requestDeletePopups({}, payload) {
    return axiosInst.springAxiosInst.post('/admin/popup/delete-popups', payload)
    .then((res) => {
      return res.data
    })
  },
}